import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  addPasskeyInputSchema,
  authenticationOptionsSchema,
  changePasswordInputSchema,
  confirmEmailChangeInputSchema,
  confirmEmailVerificationInputSchema,
  confirmPasswordResetInputSchema,
  deleteAccountInputSchema,
  deletionStartedSchema,
  emailChangedSchema,
  emailInputSchema,
  emptyInputSchema,
  endSessionInputSchema,
  oidcProviderInputSchema,
  oidcRedirectSchema,
  oidcSignedInSchema,
  oidcSignInInputSchema,
  oidcSignInStartInputSchema,
  okSchema,
  passkeySchema,
  passkeySignInInputSchema,
  passkeysSchema,
  registrationOptionsSchema,
  removePasskeyInputSchema,
  renamePasskeyInputSchema,
  requestEmailChangeInputSchema,
  sessionSchema,
  sessionsListSchema,
  signedInSchema,
  signedUpSchema,
  signInRouteSchema,
  signInInputSchema,
  signUpInputSchema,
  verifiedSchema,
} from "./auth.schemas.ts";

export const authTrpcContract = defineTrpcContract("auth", {
  session: query({ input: emptyInputSchema, output: sessionSchema }),
  signIn: mutation({ input: signInInputSchema, output: signedInSchema }),
  signUp: mutation({ input: signUpInputSchema, output: signedUpSchema }),
  signOut: mutation({ input: emptyInputSchema, output: okSchema, ownCredential: true }),
  requestPasswordReset: mutation({ input: emailInputSchema, output: okSchema }),
  confirmPasswordReset: mutation({ input: confirmPasswordResetInputSchema, output: signedInSchema }),
  requestEmailVerification: mutation({ input: emptyInputSchema, output: okSchema }),
  confirmEmailVerification: mutation({ input: confirmEmailVerificationInputSchema, output: verifiedSchema }),
  signInRoute: query({ input: emailInputSchema, output: signInRouteSchema }),
  listSessions: query({ input: emptyInputSchema, output: sessionsListSchema }),
  endSession: mutation({ input: endSessionInputSchema, output: okSchema, ownCredential: true }),
  signOutEverywhere: mutation({ input: emptyInputSchema, output: okSchema, ownCredential: true }),
  changePassword: mutation({ input: changePasswordInputSchema, output: okSchema, ownCredential: true }),
  passkeyRegistrationOptions: mutation({
    input: emptyInputSchema,
    output: registrationOptionsSchema,
    ownCredential: true,
  }),
  addPasskey: mutation({ input: addPasskeyInputSchema, output: passkeySchema, ownCredential: true }),
  listPasskeys: query({ input: emptyInputSchema, output: passkeysSchema }),
  renamePasskey: mutation({ input: renamePasskeyInputSchema, output: passkeySchema, ownCredential: true }),
  removePasskey: mutation({ input: removePasskeyInputSchema, output: okSchema, ownCredential: true }),
  passkeySignInOptions: mutation({ input: emptyInputSchema, output: authenticationOptionsSchema }),
  passkeySignIn: mutation({ input: passkeySignInInputSchema, output: signedInSchema }),
  requestEmailChange: mutation({
    input: requestEmailChangeInputSchema,
    output: okSchema,
    ownCredential: true,
  }),
  confirmEmailChange: mutation({
    input: confirmEmailChangeInputSchema,
    output: emailChangedSchema,
    ownCredential: true,
  }),
  deleteAccount: mutation({
    input: deleteAccountInputSchema,
    output: deletionStartedSchema,
    ownCredential: true,
  }),
  oidcSignInStart: mutation({ input: oidcSignInStartInputSchema, output: oidcRedirectSchema }),
  oidcLinkStart: mutation({
    input: oidcProviderInputSchema,
    output: oidcRedirectSchema,
    ownCredential: true,
  }),
  oidcSignIn: mutation({ input: oidcSignInInputSchema, output: oidcSignedInSchema }),
  oidcUnlink: mutation({ input: oidcProviderInputSchema, output: okSchema, ownCredential: true }),
});
